import {
  getNetworkType,
  getScreenHeightWidth,
  getQueryString,
  getCookie,
  isAndroidIOS,
  getLogId,
} from "./utils";

export const burying = (
  type: string,
  evLable: string,
  evParams: string,
  pid: string,
  entityId: string
) => {
  var version = getCookie("version");
  version = version !== null && version !== undefined ? version : "undefined";
  const platform = isAndroidIOS();
  const networkType = getNetworkType();
  const screen = getScreenHeightWidth();
  const sc = `${screen.width}*${screen.height}`;
  const templateId = getQueryString("templateId");
  const source = getQueryString("source");
  const city = getCookie("city");
  const cid = getCookie("xxzl_cid") || "undefined";
  // const uid = getLogUserId() || "";
  var uid = getCookie("uid");
  if (getCookie("uid") === null && getCookie("PPU") !== null) {
    const ppu = getCookie("PPU");
    const ppuArr = ppu.split("&");
    const uids = ppuArr[0].split("=")[1];
    uid = uids;
  }
  const imei = getCookie("imei") || getCookie("cimei") || "undefined";
  const mac = getCookie("58mac") || getCookie("m") || "undefined";
  const sid = getLogId() || "undefined";
  const time = new Date().getTime().toString();
  const url =
    window.location.href !== undefined
      ? encodeURIComponent(window.location.href)
      : "undefined";
  const ref =
    document.referrer !== undefined && document.referrer !== "NULL"
      ? encodeURIComponent(document.referrer)
      : "undefined";

  const trackUrl = `{'app-id':"ss",'app':"${version}",'sid':"${sid}",'tag':"w",'userid':"${uid}",'entityid':"${entityId}",'cid':"${cid}",'ev-label':"${evLable}",'ev-params':"${evParams}",'pid':"${pid}",'cityid':"${city}",'platform':"${platform}",'net':"${networkType}",'source':"${source}",'source-type':"${templateId}",'sc':"${sc}",'ts':"${time}",'imei':"${imei}",'mac':"${mac}",'url':"${url}",'ref':"${ref}",'pagetype':"punish-appeal",'page':"${evLable}"}`;
  if (type === "1") {
    try {
      window.xxzlTrack({
        trackURL: trackUrl, //uv pv
        trackParams: "", //uv pv 参数
        openMonitor: false, //是否开启监控暂是没有这个功能
      });
    } catch (e) {}
  }
  if (type === "2") {
    try {
      window.xxzlClicklog(
        `from=${evLable}&connect=punish_appeal_${pid}_${evLable}&app-id=ss&app=${version}&sid=${sid}&tag=c&userid=${uid}&entityid=${entityId}&cid=${cid}&cityid=${city}&ev-label=${evLable}&ev-params=${evParams}&pid=${pid}&platform=${platform}&net=${networkType}&source=${source}&source-type=${templateId}&sc=${sc}&ts=${time}&imei=${imei}&mac=${mac}&url=${url}&ref=${ref}`
      );
    } catch (e) {}
  }
};
